import type { JourneyRow } from "@/types";

type Props = {
  journeys: JourneyRow[];
  selectedIds: Set<string>;
  onToggle: (journeyId: string) => void;
};

export default function MonitoredJourneyChecklist({ journeys, selectedIds, onToggle }: Props) {
  return (
    <div className="mb-3 border-b border-gray-200 pb-3">
      <p className="mb-1 text-[0.7rem] font-bold tracking-wide text-gray-500 uppercase">Journeys</p>
      <ul>
        {journeys.map((journey) => (
          <li key={journey.id} className="flex items-start gap-3 border-b border-gray-100 py-3 last:border-b-0">
            <input
              type="checkbox"
              className="mt-1"
              checked={selectedIds.has(journey.id)}
              onChange={() => onToggle(journey.id)}
              aria-label={`Monitor ${journey.title}`}
            />
            <button type="button" className="cursor-pointer text-left" onClick={() => onToggle(journey.id)}>
              <span className="block font-medium text-gray-900">{journey.title}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
